import { Paper, Table, TableContainer, TableContainerProps, TableProps } from "@mui/material"
import { PropsWithChildren } from "react"

interface RPMTableProps {
    containerProps?: TableContainerProps;
    tableProps?: TableProps;
}

export const RPMTable = ({
    children, containerProps, tableProps
}: PropsWithChildren<RPMTableProps>) => {

    const component = containerProps ? containerProps.component : undefined;
    const size = tableProps ? tableProps.size : undefined;
    const containerSx = {...containerProps?.sx, marginTop: '10px'}

    return (
        <TableContainer {...containerProps} component={component ?? Paper} sx={containerSx}>
            <Table {...tableProps} size={size ?? "small"}>
                {children}
            </Table>
        </TableContainer>
    )
}
